<h3 mat-dialog-title anessaTranslation="PROJECT.INITIAL.EDIT_TEMPLATE"></h3>
<mat-dialog-content>
  <div class="text-inputs">
    <h4>email content</h4>
    <div
      (mouseenter)="showClearTemplate = true"
      (mouseleave)="showClearTemplate = false"
      class="flex-container edit-inline-row form-field-container">
      <mat-form-field appearance="outline" floatLabel="never">
        <textarea
          [(ngModel)]="emailTemplate"
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="12"
          cdkAutosizeMaxRows="12">
        </textarea>
      </mat-form-field>
      <p
        *ngIf="emailTemplate && showClearTemplate"
        class="form-field-clear"
        (click)="clearTemplate()">{{'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger}}</p>
    </div>
    <h4>signature</h4>
    <div
      (mouseenter)="showClearSignature = true"
      (mouseleave)="showClearSignature = false"
      class="flex-container edit-inline-row form-field-container">
      <mat-form-field appearance="outline" floatLabel="never">
        <textarea
          [(ngModel)]="emailSignature"
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="12"
          cdkAutosizeMaxRows="12">
        </textarea>
      </mat-form-field>
      <p
        *ngIf="emailSignature && showClearSignature"
        class="form-field-clear"
        (click)="clearSignature()">{{'PROJECT.COMMON.CLEAR' | anessaTranslation: trigger}}</p>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="fatbuttongroup">
  <button
    mat-button
    class="btn-fat btn-green"
    type="button"
    (click)="onSend()"
    anessaTranslation="PROJECT.COMMON.SEND">
  </button>
  <button
    mat-button
    class="btn-fat btn-red"
    type="button"
    (click)="onCancel()"
    anessaTranslation="PROJECT.COMMON.CANCEL">
  </button>
</mat-dialog-actions>
